<template>
    <!--  TODO: merge templates  -->
    <div v-if="poCheckEnabled || supplierReceiptsCheckEnabled" class="p-3">
        <template v-if="poCheckEnabled">
            <div class="text-bold font-18 my-2">
                PO matched items
                <span v-if="hasMatchedPoItems"
                      @click="editPoItems"
                      class="font-12 text-primary-light pl-2 clickable">
                    <i class="fa fa-pencil-alt"></i>
                </span>
            </div>
            <div v-if="hasMatchedPoItems">
                <div class="row mx-0 text-muted">
                    <div class="col-3">
                        PO number
                    </div>
                    <div class="col-3">
                        PO item sku
                    </div>
                    <div class="col-3">
                        Matched qty
                    </div>
                    <div class="col-3">
                        Unit price
                    </div>
                </div>
                <div v-for="r in line.ordered" class="row mx-0">
                    <div class="col-3 overflow-ellipsis">
                        {{ r.number }}
                    </div>
                    <div class="col-3 overflow-ellipsis">
                        {{ r.sku }}
                    </div>
                    <div class="col-3">
                        {{ getFormattedQty(r.qty) }}
                    </div>
                    <div class="col-3">
                        {{ getFormattedPrice(r.unitPrice) }}
                    </div>
                </div>
            </div>
            <div v-else class="text-muted">
                No data
            </div>
        </template>

        <template v-if="supplierReceiptsCheckEnabled">
            <div class="text-bold font-18 my-2">
                Receipts
                <span v-if="hasMatchedReceiptsItems"
                      @click="editReceiptsItems"
                      class="font-12 text-primary-light pl-2 clickable">
                    <i class="fa fa-pencil-alt"></i>
                </span>
            </div>
            <div v-if="hasMatchedReceiptsItems">
                <div class="row mx-0 text-muted">
                    <div class="col-3">
                        Number
                    </div>
                    <div class="col-3">
                        {{ $lang.item.singular }} sku
                    </div>
                    <div class="col-3">
                        Matched qty
                    </div>
                    <div class="col-3">
                        Unit price
                    </div>
                </div>
                <div v-for="r in line.receipts" class="row mx-0">
                    <div class="col-3 overflow-ellipsis">
                        {{ r.number }}
                    </div>
                    <div class="col-3 overflow-ellipsis">
                        {{ r.sku }}
                    </div>
                    <div class="col-3">
                        {{ getFormattedQty(r.qty) }}
                    </div>
                    <div class="col-3">
                        {{ getFormattedPrice(r.unitPrice) }}
                    </div>
                </div>
            </div>
            <div v-else class="text-muted">
                No data
            </div>
        </template>
    </div>
</template>

<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'
import {forceToNumber} from '@/utils'
import {MatchingExtensionTypes} from '@/types/document-viewer/extension/matching'
import {round} from 'lodash'

export default Vue.extend({
    name: 'AgGridCellRendererDetails',
    computed: {
        ...mapGetters('doc_viewer', [
            'lines'
        ]),

        ...mapGetters('doc_viewer_settings', [
            'poCheckEnabled',
            'supplierReceiptsCheckEnabled',
            'getRoundingDecimalsByFieldPath'
        ]),

        lineIdx() {
            return this.params.data ? this.params.data.lineIdx : -1
        },

        line() {
            return this.lines[this.lineIdx]
        },

        hasMatchedPoItems() {
            return this.line.ordered && this.line.ordered.length !== 0
        },

        hasMatchedReceiptsItems() {
            return this.line.receipts && this.line.receipts.length !== 0
        }
    },
    methods: {
        editPoItems() {
            this.$modal.show('matching-item-select', {
                type: MatchingExtensionTypes.PURCHASE_ORDER,
                docLineMatchTo: _.cloneDeep(this.line.ordered || []),
                docLineIdx: this.lineIdx,
                searchQuery: this.line.sku
            })
        },

        editReceiptsItems() {
            this.$modal.show('matching-item-select', {
                type: MatchingExtensionTypes.SUPPLIER_RECEIPT,
                docLineMatchTo: _.cloneDeep(this.line.receipts || []),
                docLineIdx: this.lineIdx,
                searchQuery: this.line.sku
            })
        },

        getFormattedPrice(price) {
            return round(forceToNumber(price), this.getRoundingDecimalsByFieldPath('lines.price'))
        },

        getFormattedQty(qty) {
            return round(forceToNumber(qty), this.getRoundingDecimalsByFieldPath('lines.qty'))
        }
    }
})
</script>
